import { createReducer, on, union } from '@ngrx/store';
import * as ShoppingCartActions from './shoppingCart.actions';
import { ShoppingCartState } from './shoppingCart.state';
import { ICartItem } from '../model/cartItem.model';
import { ICart } from '../model/cart.model';

export const initialShoppingCartState: ShoppingCartState = {
  cart: {} as ICart
};
 
export const shoppingCartReducer = createReducer(
    initialShoppingCartState,

    on( ShoppingCartActions.addToCartSuccess, (state , { cart }) => ({ 
      ...state, 
      cart: cart 
    })),

    on( ShoppingCartActions.removeFromCartSuccess, (state , { cart }) => ({ 
      ...state, 
      cart: cart 
    })),

    on( ShoppingCartActions.updateCartQuantitySuccess, (state , { cart }) => ({ 
      ...state, 
      cart: cart 
    })),

    on( ShoppingCartActions.getCartDataSuccess, (state , { cart }) => ({ 
      ...state, 
      cart: cart 
    })),

    on( ShoppingCartActions.emptyCartSuccess, (state , _) => ({ 
      ...state, 
      cart: {} as ICart
    }))    
);  